import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconChartColumn } from '@shared/assets/images/svgs';
import { UserRolesEnum } from '@shared/constants/auth.constants';
import { RootState, useAppSelector } from '@shared/store';
import CallAnalysisStructuredOutputSection from './CallAnalysisStructuredOutputSection';

type HeaderSectionProps = {
  title: string;
};

const HeaderSection: React.FC<HeaderSectionProps> = ({ title }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '20px',
        'svg path': {
          stroke: theme.palette.getContrastText(theme.palette.background.default),
        },
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <IconChartColumn />
        <Typography fontSize="18px" fontWeight={600}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

type CallAnalysisGeneralProps = {
  campaignId: string;
  isSquadCampaign: boolean;
};

const CallAnalysisGeneral: React.FC<CallAnalysisGeneralProps> = ({
  campaignId,
  isSquadCampaign,
}) => {
  const { t } = useTranslation();
  const currentUser = useAppSelector((state: RootState) => state.auth.authenticatedUser);
  const analysisControlsDisabled = currentUser?.role === UserRolesEnum.VIEWER;

  return (
    <Box
      sx={{
        padding: '30px',
        width: '100%',
      }}>
      <HeaderSection title={t('campaignPage.editCampaign.callAnalysis')} />
      {/* <BorderedGrid
        sx={{
          paddingTop: '20px',
          marginBottom: '20px',
        }}>
        <CustomFormLabel sx={{ mt: 0, fontWeight: 500 }} htmlFor="campaign-analysis-template">
          {t('campaignPage.callAnalysis.analysisTemplateLabel')}
        </CustomFormLabel>
        <Controller
          control={control}
          name="analysisPlan.analysisTemplate"
          disabled={analysisControlsDisabled}
          render={({ field }) => (
            <CustomTextField
              {...field}
              sx={{
                marginRight: '10px',
                marginBottom: '20px',
              }}
              value={field.value || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                field.onChange(e.target.value);
              }}
              id="campaign-analysis-template"
              variant="outlined"
              fullWidth
            />
          )}
        />
        <CustomFormLabel sx={{ mt: 0, fontWeight: 500 }} htmlFor="campaign-analysis">
          {t('campaignPage.prompt')}
        </CustomFormLabel>
        <Controller
          control={control}
          name="analysisPlan.summaryPrompt"
          disabled={analysisControlsDisabled}
          render={({ field }) => (
            <CustomTextField
              {...field}
              sx={{
                marginRight: '10px',
                '& .MuiInputBase-multiline': {
                  padding: '0px',
                },
              }}
              value={field.value || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                field.onChange(e.target.value);
              }}
              id="campaign-analysis"
              variant="outlined"
              fullWidth
              multiline
              rows={5}
            />
          )}
        />
      </BorderedGrid> */}
      <Box>
        <CallAnalysisStructuredOutputSection
          campaignId={campaignId}
          isDisabled={analysisControlsDisabled}
          isSquadCampaign={isSquadCampaign}
        />
      </Box>
    </Box>
  );
};

export default CallAnalysisGeneral;
